

















































































import { Component, Vue } from 'vue-property-decorator';
import router from '../router';
import { MedTransGoConstants } from '../util/constants';
import { validationMixin } from 'vuelidate';
import { required, minLength, numeric, alpha, maxLength } from 'vuelidate/lib/validators';
import { ACHAccount } from '../types/request';
import {EventBus} from '../main';
import { ToastEvent } from '../types/event';
interface StripeWindow extends Window {
  Stripe: any;
}
@Component({
 mixins: [validationMixin],
 props: {
    billingLocations: {
        type: Array,
        required: false,
    },
 },
 data() {
    return {
        accountHolderType: '',
        accountHolderName: '',
        accountNumber: '',
        routingNumber: '',
        currency: '',
        country: '',
        selectedLocations: [],
        billingLocationOptions: [] as any,
    };
 },
 validations: {
    accountHolderName: {
      required,
      regex: (accountHolderName) => /^[a-zA-Z0-9 ]+$/.test(accountHolderName),
    },
    accountNumber: {
        required,
        numeric,
        minLength: minLength(9),
        maxLength: maxLength(17),
    },
    routingNumber: {
        required,
        numeric,
        minLength: minLength(9),
        maxLength: maxLength(9),
    },
    currency: {
        alpha,
    },
    country: {
        alpha,
    },
 },
})
export default class ACHAccountForm extends Vue {
    private token = '';

    public mounted() {
         if (this.$props.billingLocations && this.$props.billingLocations.length) {
            this.$data.billingLocationOptions = this.$props.billingLocations.map((loc: any) => ({
            ...loc,
            locationName: loc.locationName || loc.name || '',
            }));
        }
    }

    private async getSource() {
        this.$emit(MedTransGoConstants.EVENT_CHANGE, '');
        if (!this.$v.$invalid) {
            const achAccount: ACHAccount = {
                account_holder_name: this.$data.accountHolderName,
                account_holder_type: this.$data.accountHolderType,
                routing_number: this.$data.routingNumber,
                account_number: this.$data.accountNumber,
                currency: this.$data.currency || 'USD',
                country: this.$data.country || 'US',
            };
            const stripe = (window as StripeWindow).Stripe(this.$store.state.stripePublicKey);
            const result = await stripe.createToken('bank_account', achAccount);
            if (result.error) {
                const toastEvent: ToastEvent = {
                    message: result.error.message,
                    title: 'Payment Error',
                    timeout: 5000,
                    varient: 'danger',
                };
                EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            } else {
                this.token = result.token.id;
                const paymentSource = this.token;
                const selectedLocations = this.$data.selectedLocations.map((loc: any) => loc.id);
                this.$emit(MedTransGoConstants.EVENT_CHANGE, paymentSource, selectedLocations);
            }
        }
    }

    private updateSelectedLocations() {
        const paymentSource = this.token;
        const selectedLocations = this.$data.selectedLocations.map((loc: any) => loc.id);
        this.$emit(MedTransGoConstants.EVENT_CHANGE, paymentSource, selectedLocations);
    }

}
